import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Group = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    margin-top: ${props => (props.marginTop ? props.marginTop : '0')};

    button:first-child,
    div:first-child,
    .middleButton {
        margin-right: 0.5em;
    }

    button:last-child,
    div:last-child {
        margin-left: 0.5em;
    }
`;

const TwoGroup = props => <Group {...props}>{props.children}</Group>;

TwoGroup.propTypes = {
    children: PropTypes.array.isRequired
};

export default TwoGroup;



// WEBPACK FOOTER //
// ./src/components/TwoGroup.jsx